import { Doctor, NewOrUpdatedDoctor } from 'features/doctors/types'
import clientApi from '../../api/clientApi'

const apiEndpoint = process.env.REACT_APP_REPASSE_API_ENDPOINT

export const getDoctorsRelatedToHospital = async (
  hospitalId: number
): Promise<Doctor[]> => {
  const { data } = await clientApi.get<Doctor[]>(
    `${apiEndpoint}/doctors/hospital/${hospitalId}`
  )
  return data
}

export const getDoctorFromLoggedUser = async (): Promise<{
  doctorCreated: boolean
  doctor: Doctor
}> => {
  const { data } = await clientApi.get<{
    doctorCreated: boolean
    doctor: Doctor
  }>(`${apiEndpoint}/doctors/me`)

  return data
}

export const create = async (doctor: NewOrUpdatedDoctor): Promise<Doctor> => {
  const { data } = await clientApi.post(`${apiEndpoint}/doctors`, doctor)
  return data
}

export const update = async (doctor: NewOrUpdatedDoctor): Promise<Doctor> => {
  const { data } = await clientApi.patch(`${apiEndpoint}/doctors`, doctor)
  return data
}
